import React, { useState } from 'react';
import { Container, Box, Typography, Button, Paper } from '@mui/material';
import { LibraryBooks, Link as LinkIcon, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MasterProductBrowser from '../components/MasterProductBrowser';
import AutoLinkDialog from '../components/AutoLinkDialog';
import { useSelectedLocation } from '../../../hooks/useSelectedLocation';

export default function MasterProductLibrary() {
  const navigate = useNavigate();
  const [autoLinkOpen, setAutoLinkOpen] = useState(false);
  const selectedLocation = useSelectedLocation();

  // Use the selected location from sidebar
  const retailerId = selectedLocation;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: 4 }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate('/products')}
            sx={{ mb: 2 }}
          >
            Back to Products
          </Button>

          <Paper sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <LibraryBooks sx={{ fontSize: 40, color: 'primary.main' }} />
                <Box>
                  <Typography variant="h4" gutterBottom>
                    Master Product Library
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    Browse thousands of pre-loaded products with images, nutrition data, and more
                  </Typography>
                </Box>
              </Box>

              <Button
                variant="contained"
                startIcon={<LinkIcon />}
                onClick={() => setAutoLinkOpen(true)}
                size="large"
              >
                Auto-Link Products
              </Button>
            </Box>
          </Paper>
        </Box>

        {/* Product Browser */}
        <MasterProductBrowser retailerId={retailerId} />
      </Container>

      {/* Auto-Link Dialog */}
      <AutoLinkDialog
        open={autoLinkOpen}
        onClose={() => setAutoLinkOpen(false)}
        retailerId={retailerId}
      />
    </Box>
  );
}
